import React, { useEffect, useState } from "react"
import { orderBy, sortBy } from "lodash"
import BackOfficeAPIClient from "../../clients/BackofficeAPIClient"
import { SelectOption } from "../CategorieClient/List"
import { People } from "../../types/People"
import { WorkflowValidation } from "../../types/WorklowValidation"
import ModalCreationWorkflow from "./ModalCreationWorkflow"

declare const window: any

export default function Index() {

    const backofficeApiClient = new BackOfficeAPIClient()

    const [ dealershipsOptions, setDealershipsOptions ] = useState<SelectOption[]>([])
    const [ fetchingWorkflows, setFetchingWorkflows ] = useState<boolean>(true)
    const [ users, setUsers ] = useState<People[]>([])
    const [ selectedWorkflow, setSelectedWorkflow ] = useState<WorkflowValidation>()
    const [ workflows, setWorkflows ] = useState<WorkflowValidation[]>([])

    useEffect(() => {
        fetchDealerships()
        fetchUsers()
        fetchWorkflows()
    }, [])

    const fetchWorkflows = async () => {
        try {
            setFetchingWorkflows(true)
            setWorkflows([])
            const json = await backofficeApiClient.get<WorkflowValidation[]>("/workflowsValidation")
            setWorkflows(json)
        } catch {
            throw new Error("Erreur lors de la récupération des workflows de validation")
        } finally {
            setFetchingWorkflows(false)
        }
    }

    const fetchUsers = async () => {
        try {
            const json = orderBy(await backofficeApiClient.get<any[]>("/utilisateurs"), "Name")
            setUsers(json)
        } catch {
            throw new Error("Erreur lors de la récupération des utilisateurs")
        }
    }

    const fetchDealerships = async () => {
        try {
            let json = orderBy(await backofficeApiClient.get<any[]>("/sites"), "Libelle")
            json = json.filter((item) => item.Libelle !== "")
            json = sortBy(json, (dealership) => dealership.Libelle)
            setDealershipsOptions(json.map((dealership) => {
                return {
                    label: dealership.Libelle,
                    value: dealership.IDSite,
                } as SelectOption
            }))
        } catch {
            throw new Error("Erreur lors de la récupération des sites")
        }
    }

    const deleteWorkflow = async () => {
        try {
            if (selectedWorkflow) {
                await backofficeApiClient.delete(`/workflowsValidation`, { IDWorkflowValidation: selectedWorkflow.IDWorkflowValidation })
                setSelectedWorkflow(undefined)
                document.getElementById("closeButtonDeleteWorkflowModal")?.click()
                await fetchWorkflows()
            }
        } catch {
            throw new Error("Erreur lors de la suppression du workflow de valdiation")
        }

    }

    useEffect(() => { window.$('[data-toggle="tooltip"]').tooltip()}, [ workflows ])

    return (
        <div className="tw-mx-4 tw-h-full">
            <div className="tw-flex tw-flex-row">
                <h2 className="tw-mb-4">Paramétrage Workflows de validation</h2>
            </div>
            <button type="button" className="btn btn-light" data-toggle="modal" data-target="#createModal">
                <i className="fa fa-plus"></i> Ajouter un workflow
            </button>
            <ModalCreationWorkflow
                dealerships={dealershipsOptions}
                users={users}
                workflow={selectedWorkflow}
                isEdition={!!selectedWorkflow}
                setSelectedWorkflow={setSelectedWorkflow}
                fetchWorkflows={fetchWorkflows}
                workflows={workflows}
            />
            <div data-backdrop="static" className="modal fade" id="deleteModal" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirmation</h5>
                            <button onClick={() => setSelectedWorkflow(undefined)} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Êtes-vous sûr de vouloir supprimer ce workflow ?
                        </div>
                        <div className="modal-footer">
                            <button id="closeButtonDeleteWorkflowModal" onClick={() => setSelectedWorkflow(undefined)} type="button" className="btn btn-secondary" data-dismiss="modal">Annuler</button>
                            <button onClick={deleteWorkflow} type="button" className="btn btn-danger">Supprimer</button>
                        </div>
                    </div>
                </div>
            </div>
            <table className="table table-bordered bg-white tw-mt-4">
                <thead>
                <tr>
                    <th scope="col">Site</th>
                    <th scope="col">Editer une offre</th>
                    <th scope="col">Validateurs offre</th>
                    <th scope="col">Editer une commande</th>
                    <th scope="col">Validateurs commande</th>
                    <th scope="col">Actions</th>
                </tr>
                </thead>
                <tbody>
                {fetchingWorkflows && (
                    <tr className={"bg-light tw-text-center"}>
                        <td colSpan={6}>
                            <span>Récupération des workflows en cours ... </span>
                        </td>
                    </tr>
                )}
                {(workflows.length === 0 && !fetchingWorkflows) && (
                    <tr className={"bg-light tw-text-center"}>
                        <td colSpan={6}>
                            <span>Il n'y a aucun workflow pour le moment</span>
                        </td>
                    </tr>
                )}
                {workflows.map((workflow: WorkflowValidation) => {
                    const peopleOffre = users.filter(u =>
                        workflow.EditionOffrePeopleIds.includes(Number(u.IDPeople)),
                    )
                    const peopleCommande = users.filter(u =>
                        workflow.EditionCommandePeopleIds.includes(Number(u.IDPeople)),
                    )

                    // Formatte les labels (nom + "+x")
                    const labelPeopleOffre =
                        peopleOffre.length > 0
                            ? `${peopleOffre[0].Name}${peopleOffre.length > 1 ? ` +${peopleOffre.length - 1}` : ""}`
                            : "—"

                    const labelPeopleCommande =
                        peopleCommande.length > 0
                            ? `${peopleCommande[0].Name}${peopleCommande.length > 1 ? ` +${peopleCommande.length - 1}` : ""}`
                            : "—"

                    const tooltipMessageOffre = peopleOffre.length > 1 ? peopleOffre.map((p) => p.Name).join(",\n") : ""
                    const tooltipMessageCommande = peopleCommande.length > 1 ? peopleCommande.map((p) => p.Name).join(",\n") : ""

                    return (
                        <tr key={workflow.IDWorkflowValidation} className={"bg-light"}>
                            <td>{dealershipsOptions.find(d => Number(d.value) === workflow.IDSite)?.label ?? ""}</td>
                            <td>
                                {workflow.EditionOffre ? "Validation nécessaire" : "Pas de validation"}
                            </td>
                            <td>
                                <span data-toggle="tooltip" data-trigger="hover" data-placement="top" data-html="true" title={tooltipMessageOffre} style={{ whiteSpace: 'pre-line' }}>
                                {labelPeopleOffre}
                            </span>
                            </td>
                            <td>
                                {workflow.EditionCommande ? "Validation nécessaire" : "Pas de validation"}
                            </td>
                            <td>
                                 <span data-toggle="tooltip" data-trigger="hover" data-placement="top" data-html="true" title={tooltipMessageCommande} style={{ whiteSpace: 'pre-line' }}>
                                {labelPeopleCommande}
                            </span>
                            </td>
                            <td>
                                <div className="tw-flex tw-justify-around">
                                    <button onClick={() => setSelectedWorkflow(workflow)} type="button" className="btn btn-primary btn-sm" data-toggle="modal" data-target="#createModal">
                                        <i className="fa fa-pencil"></i>
                                    </button>
                                    <button onClick={() => setSelectedWorkflow(workflow)} type="button" className="btn btn-danger btn-sm" data-toggle="modal"
                                            data-target="#deleteModal">
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    )
}
